module.exports = __webpack_public_path__ + "img/bheka-funda-digi-merged-logo.054780b5.png";